import { render, staticRenderFns } from "./Resumo.vue?vue&type=template&id=ced719c6&scoped=true&"
import script from "./Resumo.vue?vue&type=script&lang=js&"
export * from "./Resumo.vue?vue&type=script&lang=js&"
import style0 from "./Resumo.vue?vue&type=style&index=0&id=ced719c6&scoped=true&lang=css&"
import style1 from "./Resumo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced719c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBadge,VCard,VContainer,VFlex,VIcon,VLayout})
